import { Component, HostListener, Input, OnInit, OnChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { InteractionHistoryService } from '../../../services/interaction-history.service';
import { IHTransferDetail } from '../interaction-history-list-view/interaction-history-list-view.component';
// CCR3-2685
import * as Constants from '../../../models/Constants';
import _ from 'lodash';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RootScopeService } from 'src/app/services/root-scope.service';
import { ApiService } from 'src/app/services/api.service'
import { OpenMessageComponent } from '../open-message/open-message.component';
import { DocumentData } from 'src/app/models/DocumentData';
import { ThemePalette } from '@angular/material/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { LogService } from 'src/app/services/log.service';
import { ViewNoteLogComponent } from '../view-note-log/view-note-log.component';

export interface PeriodicElement {
  approvedExcetionType: string;
  approvedExcetionSubtype: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  { approvedExcetionType: 'Approved Excetion Type 1', approvedExcetionSubtype: 'Approved Excetion Subtype 1' },
  { approvedExcetionType: 'Approved Excetion Type 2', approvedExcetionSubtype: 'Approved Excetion Subtype 2' },
  { approvedExcetionType: 'Approved Excetion Type 3', approvedExcetionSubtype: 'Approved Excetion Subtype 3' },
];


export interface IHTransferDetail1 {
  AccountOpened: string;
  Reason: string;
  Role: string;

}
const ADDITIONAL_DATA: IHTransferDetail1[] = [
  //Static Data has been  used to show the table, and should be removed when consumed by Features.
  {
    AccountOpened: 'McDermott, Patrick',
    Reason: 'Authorized user ',
    Role: 'HR/Manager '

  },
  {
    AccountOpened: 'John Doe',
    Reason: 'Agent ',
    Role: 'Michael A'

  }
];
@Component({
  selector: 'app-interaction-history-detail-view',
  templateUrl: './interaction-history-detail-view.component.html',
  styleUrls: ['./interaction-history-detail-view.component.scss']
})
export class InteractionHistoryDetailViewComponent implements OnInit, OnChanges {

  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  value = 0;

  @Input() loaderType!: string;
  @Input() loaderMsg!: boolean;

  @Input() totalRecords: number = 0;
  @Input() selectedIHData: any = {};
  showViewTopic: boolean = false;
  showTransferDetail: boolean = false;
  showAdditionalInfo: boolean = false;
  showAdditionalAccountInfo: boolean = false;
  //CCR3-13170 show multiple account details only when there are multiple accounts associated with the conversation.
  showMultipleAccountDetail: boolean = false;

  //CCR6-1346
  displayedColumns: string[] = ['approvedExcetionType', 'approvedExcetionSubtype'];
  data = ELEMENT_DATA;

  // CCR3-2681
  constant = Constants.selectionType;
  carePortal = Constants.CARE_PORTAL
  approveExceptionListData: any;
  DATA_NOT_ON_FILE = Constants.DATA_NOT_ON_FILE;
  topicList: any[] = [];
  topicArrow = Constants.TOPIC_ARROW;
  displaySecurityMethod: boolean = false;
  wrapUpObj: any;
  securityMethod: boolean = false;
  securityMethodVal: string = '';
  viewDocumentLoader: boolean = false;
  documentViewApiFailed: boolean = false;
  showEditCommentsModal: boolean = false;
  onDemandEmailEvent = Constants.ONDEMAND_EMAIL_EVENT;
  onDemandStatusCode = Constants.ONDEMAND_EMAIL_STATUS_CODE;
  DATE_NOT_FOUND = Constants.DATE_NOT_FOUND;
  docType = Constants.docType;
  fileName: string = 'interactionHistoryDetailViewComponent';
  authChannel: string = ''; // CCR3-10820
  systemImaging = Constants.SYSTEM_IMAGING; // CCR1-11727;

  constructor(public dialog: MatDialog, public intHistService: InteractionHistoryService, public rootScope: RootScopeService, private http: HttpClient, private apiService: ApiService,private logService: LogService) { }

  @HostListener('window:resize', []) resize() {
    this.showViewTopic = !this.showViewTopic;
    this.showTransferDetail = !this.showTransferDetail;
    this.showAdditionalInfo = !this.showAdditionalInfo;
    this.showAdditionalAccountInfo = !this.showAdditionalAccountInfo;
    this.showMultipleAccountDetail = !this.showMultipleAccountDetail;

  }

  TRANSFER_DATA: IHTransferDetail[] = [
    //Static Data has been  used to show the table, and should be removed when consumed by Features.
    {
      TransferDate: 'Dec-10-2023',
      StartTime: '10:43:58 a.m. ',
      StopTime: '01:23:45p.m ',
      AgentName: 'Michael A',
      Topic: 'Lorem ipsum'
    },
    {
      TransferDate: 'Dec-10-2023',
      StartTime: '10:43:58 a.m. ',
      StopTime: '01:23:45p.m ',
      AgentName: 'Michael A',
      Topic: 'Lorem ipsum'
    }
  ];

  ADDITIONAL_DATA: IHTransferDetail1[] = [
    //Static Data has been  used to show the table, and should be removed when consumed by Features.
    {
      AccountOpened: 'McDermott, Patrick',
      Reason: 'Authorized user ',
      Role: 'HR/Manager '

    },
    {
      AccountOpened: 'John Doe',
      Reason: 'Agent ',
      Role: 'Michael A'

    }
  ];

  displayedData: string[] = [
    'TransferDate',
    'StartTime',
    'StopTime',
    'AgentName',
  ];

 // CCR3-13170
   displayedMultipleData: string[] = [
    'CustomerName',
    'StartTime',
    'StopTime',
  ];

  displayedAdditionalData: string[] = [
    'AccountOpened',
    'Reason',
    'Role',

  ];

  additionInfo: string[] = ['keyName', "keyValue"];
  // bucketListArr:string[] = 

  ngOnInit(): void {
    // console.log("Method detailed view ngOnit called")
    this.intHistService.commentValChanged.subscribe((data)=>{
      if(data && this.selectedIHData && this.selectedIHData?.documentDetail?.details){
        this.selectedIHData.documentDetail.details = this.intHistService.clonedFormObject.value.comments ;
        this.intHistService.editWrapupCommentsForm.reset();
      }
    })
  }

  ngOnChanges(changes) {
    this.approveExceptionListData = [];
    this.rootScope.activeCustTab.documentViewApiFailed = false; // CCR1-12776 resetting document view api failure state on data change
   
  }

  getPhoneNumber(phoneNum) {
    if (!phoneNum || phoneNum == '' || phoneNum == undefined) {
      return this.DATA_NOT_ON_FILE;
    }

    if (phoneNum?.includes(":"))
      return phoneNum.split(":")[1];
    else
      return phoneNum;
  }

  getSecurityLevel(keyName) {
    let obj = _.find(this.selectedIHData?.documentDetail?.buckets, (each) => {
      return each?.keyName == keyName
    })
    if (obj) {
      return obj?.keyValue;
    }
    else
      return 'N/A';

  }



  /**
   * @author Bharat Trikha
   * @description Add for the user story CCR1-3446 .
   * getButtonTitle method make the title attribute of the button determined dynamically 
   * based on the channel value.
   * @param channel 
   * @returns 
   */
  getButtonTitle(channel: string) {
    if (channel === Constants.docType.email || channel === Constants.docType.text) {
      return `View ${channel}`;
    } else if (channel === Constants.docType.document) {
      return 'Open Document';
    } else {
      return '';
    }
  }

  /**
   * @author Bharat Trikha
   * @description Added for CCR1-3446 . This method convert given date in MMM-DD-YYYY format.
   * @param date 
   * @returns 
   */
  getDate(date: any) {
    if (date) {
      const formattedDate: any = this.rootScope.getDate(date);
      return formattedDate === 'Invalid date' ? date : formattedDate;
    } else {
      return Constants.DATE_NOT_FOUND;
    }
  }

  /**
   * @description Added for CCR1-3446 . This method is checking if the data value is trusthy , 
   * if not then returning Data not on file.
   * @param data 
   * @returns 
   */
  getFieldData(data: any): any {
    return data ? data : Constants.DATA_NOT_ON_FILE;
  }


  /**
   * Method is used to open view note log documents in care portal.   * 
   */


   openViewNoteLog() {
      this.dialog.open(ViewNoteLogComponent, {
        data:{
          docId: this.selectedIHData?.csProDocDetails?.docId
        },
        panelClass: 'view-note-log',
        backdropClass: 'custom-overlay',
        disableClose: true,
        id: 'view-note-log'
      });
    } 



  /**
   * Method will check security level of the customer tab , if CS_SECURITY_LEVEL !=4 in case of live call
   * then return true which means view document link will be disable
   * @returns 
   */
  checkSecurityLevel(selectedIHData: any): boolean {
    if (!this.rootScope.isLiveCall) {
      return false;
    }

    if (selectedIHData?.channel == Constants.docType.document) { 
         return false; // CCR1-12934 - Documents should be accessible for all security levels in live call as per AC, so returning false for document channel.
       
    }
    else{

    if (this.rootScope.activeCustTab.isAdditionalAccOpen) {
      const additionalAccConversationId = this.rootScope.activeCustTab.conversationId;
      const parentTab = this.rootScope.customerTabs.find(tab => tab.conversationId === additionalAccConversationId);
      return !!(parentTab && parentTab.CS_SECURITY_LEVEL !== '4');
    } else {
      return this.rootScope.activeCustTab.CS_SECURITY_LEVEL !== '4';
    }
  }
  }



  /**
   * CCR1-12934
   * @param selectedIHData 
   * @returns 
   */
  disableOpenDocumentForControlD(selectedIHData: any): boolean {
    if(selectedIHData?.channel === Constants.docType.document && selectedIHData?.csProDocDetails?.system === this.docType.authNotice){
      return true;
    }
    

  if (selectedIHData?.channel === Constants.docType.document && selectedIHData?.csProDocDetails?.system === this.docType.controlD) {
    if ((selectedIHData?.csProDocDetails?.status?.toLowerCase() === Constants.ControlDDocumentType.READY_TO_CREATE.toLowerCase() ||
         selectedIHData?.csProDocDetails?.status?.toLowerCase() === Constants.ControlDDocumentType.CANCELLED.toLowerCase() ||
         selectedIHData?.csProDocDetails?.status?.toLowerCase() === Constants.ControlDDocumentType.CANCEL.toLowerCase())
       && selectedIHData?.csProDocDetails?.deliveryMode?.toLowerCase() === Constants.ControlDDocumentType.EDS.toLowerCase())
     {
      return true;
    }
    else{
      return false;
    }
  }
  else{
    return false;
  }
}

  /**
   * Method is used to open document and messages in care portal.
   * @param selectedIHData 
   */
  openDocumentOrMessage(selectedIHData: any) {
    if (selectedIHData?.channel === Constants.docType.document&& selectedIHData?.csProDocDetails?.system === Constants.docType.authNotice) {
      return;
    }
    if (selectedIHData?.channel === Constants.docType.document) {

      //if (this.rootScope.isTBAGUIRegistrationCompleted()) {

        /**
         * if this.rootScope.activeCustTab.id and document id exist in the customerTbaDocumentsMap ,
         * then call openDoc directly .If not then do a API call to fetch document data.
         */

        this.viewDocumentLoader = true;
        this.rootScope.activeCustTab.documentViewApiFailed = false;


          let paramsObject = {
            clientId: this.rootScope.activeCustTab.clientId,
            formId: selectedIHData?.csProDocDetails?.formId,
            system: selectedIHData?.csProDocDetails?.system,
            documentName: selectedIHData?.csProDocDetails?.docName,
            docType: selectedIHData?.csProDocDetails?.type
          };

          if (selectedIHData?.csProDocDetails?.mailboxItemId !== undefined && selectedIHData?.csProDocDetails?.mailboxItemId !== '') {
            paramsObject['mailBoxItemId'] = selectedIHData?.csProDocDetails?.mailboxItemId;
            paramsObject['domain'] = selectedIHData?.csProDocDetails?.domain;
          }
// This is for story CCR2-4943
          if (selectedIHData?.csProDocDetails?.system === 'Control-D') {
            paramsObject['domain'] = selectedIHData?.csProDocDetails?.domain;
            if (selectedIHData?.csProDocDetails?.statusDate){
             paramsObject['effectiveDate'] = selectedIHData?.csProDocDetails?.statusDate;
            }
             }

      this.apiService.getDataToViewDocument(paramsObject).subscribe({
        next: (arrayBuffer: ArrayBuffer) => {
          // Handle the successful response with binary data
          this.openDoc(arrayBuffer, decodeURIComponent(selectedIHData?.csProDocDetails?.docName));
          this.storeDocumentInfo(this.rootScope.activeCustTab.customerSessionId, arrayBuffer, decodeURIComponent(selectedIHData?.csProDocDetails?.docName), selectedIHData?.csProDocDetails?.docId);
        },
        error: (error) => {
          // Handle errors
          this.viewDocumentLoader = false;
          this.rootScope.activeCustTab.documentViewApiFailed = true;
          console.error('Error occurred:', error);
        }
      });


      // } else {
      //   this.rootScope.enableAlerts(Constants.WARNING, Constants.TBA_NOT_REGISTERED_MSG);
      // }
    } else {
      this.dialog.open(OpenMessageComponent, {
        panelClass: 'interaction-history-dialog',
        backdropClass: 'custom-overlay',
        id: 'OpenMsg',
        data: selectedIHData
      });
    }

  }

  /**
   * This method is used to store the document information in rootScope map which will be later used to show the recently viewed documents in TBA GUI.
   * @param customerSessionId 
   * @param arrayBuffer 
   * @param docName 
   * @param docId 
   */
  storeDocumentInfo(customerSessionId: any, arrayBuffer: ArrayBuffer, docName: any, docId: any) {

    const documentData = new DocumentData(docName, docId, arrayBuffer);
    if (this.rootScope.customerTbaDocumentsMap.has(customerSessionId)) {
      const documentDataList: DocumentData[] = this.rootScope.customerTbaDocumentsMap.get(customerSessionId);
      documentDataList.push(documentData);
    } else {
      const documentDataList: DocumentData[] = [documentData];
      this.rootScope.customerTbaDocumentsMap.set(customerSessionId, documentDataList)
    }
  }


  /**
   * This method take input as filename and document data in the form of arraybuffer.
   * And to an API call to TBA which open the document in TBA GUI Web Front.
   * @param data 
   * @param filename 
   * CCR1-12013 method updated  from prmise to observable
   */
  openDoc(data: ArrayBuffer, filename: string) {
    const url = this.buildURL(filename);
    const formData = new FormData();
    formData.append('file', new Blob([data]), filename);

     this.http.post(url, formData).subscribe({
      next: (response) => {
        this.viewDocumentLoader = false;
        console.log('Byte array uploaded successfully');
      },error: (error) => {
        console.error('Error uploading byte array');
        this.viewDocumentLoader = false;
        this.logService.errorLogs("TBA-OPENDOC-FAILURE: " + error?.error, this.fileName);
        if (error?.error == 'Invalid Environment.') this.rootScope.enableAlerts(Constants.ERROR, Constants.TBA_CONS['Invalid Environment.']);
        else this.rootScope.enableAlerts(Constants.WARNING, Constants.TBA_NOT_REGISTERED_MSG);
      }
  });

  }

  /**
   * This method create an URL which will be used to open document in TBA GUI WebFront.
   * @param filename 
   * @returns 
   */
  buildURL(filename: String) {
    const port = sessionStorage.getItem('tba_port');
    const sessionId = sessionStorage.getItem('tba_sessionId');
    let groupName = this.rootScope.activeCustTab.customerSessionId + '/' + filename;
    const url = 'https://localhost:' + port + '/doc/' + sessionId + '/' + groupName;
    return url;
  }


  /** Get QueueName from buckets - CCR1-3858 - @author-Pooja  */
  getQueueNameFromIH(bucketListArr) {
    return this.getValueFromBuckets(bucketListArr, Constants.QUEUE_NAME_KEY_BUCKET);
  }

  /**Get WrapUpObj = CCr1-3858 -@author -Pooja */
  getWrapUpObj(bucketListArr) {
    let obj = _.find(bucketListArr, (each) => {
      return each?.keyName == Constants.WRAP_UP_KEY_BUCKET;
    })
    this.wrapUpObj = obj?.keyValue;

    // CCR1-12830 Normalize 'where' & 'other' fields for display fallback in case of refresh/crash scenarios
    if (this.wrapUpObj) {

      if (!this.wrapUpObj?.where) {
        this.wrapUpObj.where = this.wrapUpObj?.whereSingleSelect
          || (Array.isArray(this.wrapUpObj?.whereMultiSelect) && this.wrapUpObj?.whereMultiSelect?.length
            ? this.wrapUpObj?.whereMultiSelect?.join(', ')
            : '')
          || '';

      }

      if (this.wrapUpObj?.whereOtherText &&
        this.wrapUpObj?.whereOtherText !== this.wrapUpObj?.whereOtherText?.toUpperCase()) {
        this.wrapUpObj.whereOtherText = this.wrapUpObj?.whereOtherText?.toUpperCase();
      }

    }
    
    return this.wrapUpObj;
  }

  /** Get Interaction Secured Value from buckets - CCR1-3858  - @author-Pooja **/
  getInteractSecuredValFromIH(bucketListArr) {
    this.getWrapUpObj(bucketListArr);
    this.getApprovedExceptionDataFromIH(bucketListArr);
    let val = this.getValueFromBuckets(bucketListArr, Constants.INTERACTION_STATUS_SECURED_KEY_BUCKET);
    
    if (val == "Yes"||this.getSecurityMethodFromIH(bucketListArr)==Constants.AuthMethods["PIN-REMINDER"]) {
      // this.displaySecurityMethod = true;
      let securityMethodCode = this.getSecurityMethodFromIH(bucketListArr);
      this.securityMethodVal = Constants.AuthMethods[securityMethodCode] ? Constants.AuthMethods[securityMethodCode] : securityMethodCode;
      this.authChannel= this.getValueFromBuckets(bucketListArr, Constants.AUTH_CHANNELS.authKeyName); // CCR3-10820
     
    }
    else {
      // this.displaySecurityMethod = false;
      this.securityMethodVal = '';
      this.authChannel = '';
     // this.approveExceptionListData = [];
    }
    return val;
  }

  /** Get Security Method Value from buckets - CCR1-3858  - @author-Pooja **/
  getSecurityMethodFromIH(bucketListArr) {
    return this.getValueFromBuckets(bucketListArr, Constants.SECURITY_METHOD)
  }

  /** Get Approved Exception  Table Data from buckets - CCR1-3858  - @author-Pooja **/
  getApprovedExceptionDataFromIH(bucketListArr) {
    this.approveExceptionListData = this.getValueFromBuckets(bucketListArr, Constants.APPROVED_EXCEPTION_KEY_BUCKET);
    if (this.approveExceptionListData == Constants.DATA_NOT_ON_FILE) {
      this.approveExceptionListData = [];
    }
  }

  /**
   * Fetching values from buckets
   * @param buckets
   * @returns respective Value for respective KeyName
   * @author :Pooja  / CCR1-3858
   */

  getValueFromBuckets(bucketListArr, keyName) {
    let obj = _.find(bucketListArr, (each) => {
      return each?.keyName == keyName;
    })

    if (obj) {
      return obj?.keyValue;
    }
    else {
      return Constants.DATA_NOT_ON_FILE;
    }
  }

  /**As per AC in CCR1-3858 , approved exception table will be visible only Security 
     * method is "Approbved Exception" */
  showApprovedExcceptionTable() {
    if (this.approveExceptionListData?.length) {
      return true;
    }
    else {
      return false;
    }
  }

  /***
   * 
   */

  getSecondaryTopicsList() {
    if (this.wrapUpObj) {
      let that = this;
      this.topicList = this.wrapUpObj?.wrapupTopicList?.filter(function (each) {
        return that.wrapUpObj.primaryTopic != each?.domain + Constants.TOPIC_ARROW + each?.topic + Constants.TOPIC_ARROW + each?.subTopic;
      });

      if (this.topicList && this.topicList.length > 0) {
        return true;
      }
    }
    return false;
  }


  getContactType() {
    let custType = this.selectedIHData?.documentDetail?.contact?.type;
    let obj = this.rootScope.customerTypeData.find(xx => xx?.fieldValue == custType);
    if (obj) {
      return obj?.fieldValueDescription;
    }
    else {
      return Constants.DATA_NOT_ON_FILE;
    }
  }

  /*Domain will be domain of primary topic -CCR1-3858  */
  getDomain(topic) {
    if (topic) {
      let domainName = topic?.split(Constants.TOPIC_ARROW);

      if (domainName)
        return domainName?.[0];
      else
        return Constants.DATA_NOT_ON_FILE;
    }
    else {
      return Constants.DATA_NOT_ON_FILE;
    }
  }

  isOnDemandEmail(): boolean {
   if(this.selectedIHData?.documentDetail?.channel === Constants.docType.email && this.selectedIHData?.documentDetail?.system === 'careportal'){
     return true;
   }else{
    return  false;
   }
  }

  getEmailDestination(){
   if(this.isOnDemandEmail() ){
    return this.getFieldData(this.selectedIHData?.documentDetail?.contact?.emailAddress) ;
   } 
   else{
     return this.getFieldData(this.selectedIHData?.messageDetails?.destinationAddress);
   }
  }

  getEmailName(){
    if( this.isOnDemandEmail()){
      return this.getFieldData(this.selectedIHData?.documentDetail?.details)
    }
    else{
      return this.getFieldData(this.selectedIHData?.messageDetails?.msgName);
    }
  }

  getEmailActivity(){
    if(this.isOnDemandEmail()){
      return this.onDemandEmailEvent ;
    } 
    else{
      return this.getFieldData(this.selectedIHData?.messageDetails?.event);
    }
  }

  getEmailSubject(){
    if(this.isOnDemandEmail()){
      return this.getFieldData(this.selectedIHData?.documentDetail?.description);
    } 
    else{
      return this.getFieldData(this.selectedIHData?.messageDetails?.msgSubject);
    }
  }

  getStatusCode(){
    if(this.isOnDemandEmail()){
      return  this.onDemandStatusCode;
    } 
    else{
      return this.getFieldData(this.selectedIHData?.messageDetails?.statusCode);
    }
  }

  getSentDate(){
    if(this.isOnDemandEmail()){
      return  this.getDate(this.selectedIHData?.documentDetail?.end);
    } 
    else{
      return this.getDate(this.selectedIHData?.messageDetails?.sentDate);
    }
  }

  getSourceSystem(){
    if(this.isOnDemandEmail()){
      return  this.carePortal;
    } 
    else{
      return this.getFieldData(this.selectedIHData?.messageDetails?.sourceSystem);
    }
  }

  getFirstViewDate(){
    if(this.isOnDemandEmail()){
      return  this.DATE_NOT_FOUND;
    } 
    else{
      return this.getDate(this.selectedIHData?.messageDetails?.firstViewDate);
    }
  }

  getLastViewDate(){
    if(this.isOnDemandEmail()){
      return  this.DATE_NOT_FOUND;
    } 
    else{
      return this.getDate(this.selectedIHData?.messageDetails?.lastViewDate);
    }
  }

  getReturnedDate(){
    if(this.isOnDemandEmail()){
      return  this.DATE_NOT_FOUND;
    } 
    else{
      return this.getDate(this.selectedIHData?.messageDetails?.returnedDate);
    }
  }

  getReturnedReason(){
    if(this.isOnDemandEmail()){
      return  this.DATA_NOT_ON_FILE;
    } 
    else{
      return this.getFieldData(this.selectedIHData?.messageDetails?.returnedReason);
    }
  }

 
  /**
   * Ask is edit icon should get enabled only in research mode
   * @Pooja
   * @returns 
   */
  enableEditCommentIcon(){
    if(this.rootScope.activeCustTab.activeCall || this.rootScope.activeCustTab.activeChat){
      return true;
    }
    else{
      return false;
    }
  }

  /**
   * CCR1-7186
   * @author:Pooja
   */

  openEditComments() {   
    this.intHistService.selectedIHForWrapUpCommentsEdit = _.cloneDeep(this.selectedIHData);
    this.intHistService.editWrapupCommentsForm?.get('comments')?.setValue(this.intHistService.selectedIHForWrapUpCommentsEdit?.documentDetail?.details);
    this.rootScope.activeCustTab.showEditCommentsModal = true;

    
  }
 
}
